import React, { useEffect } from 'react';
// Helper functions for Meta Pixel event tracking
// Pixel initialization is handled in App.tsx useEffect
export function trackEvent(event: string, data?: Record<string, unknown>) {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', event, data);
  }
}
export function trackPageView() {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'PageView');
  }
}